export const WHITE = 'w'
export const WHITE_KING = 'W'
export const BLACK = 'b'
export const BLACK_KING = 'B'
export const BOARD_BASE_SIZE = 8
